import { useEffect, useState } from "react";
import {
  readSidebarPreferences,
  type SidebarMode,
  saveSidebarPreferences,
  sidebarMode,
  sidebarWidth,
} from "./sidebarPreferences";

export function useSidebarLayout(scope: string) {
  const [width, setWidth] = useState(() => sidebarWidth(window.innerWidth));
  const [stored, setStored] = useState(() => ({ scope, preferences: readSidebarPreferences(scope) }));
  const preferences = stored.scope === scope ? stored.preferences : {};
  useEffect(() => {
    setStored({ scope, preferences: readSidebarPreferences(scope) });
  }, [scope]);
  useEffect(() => {
    const update = () => setWidth(sidebarWidth(window.innerWidth));
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  function choose(mode: SidebarMode) {
    const next = { collapsed: mode === "drawer" };
    setStored({ scope, preferences: next });
    saveSidebarPreferences(scope, next);
  }

  return { width, mode: sidebarMode(width, preferences), choose };
}
